module.exports = __webpack_public_path__ + "static/oldpiano2-2a8b5d915f31d8392d7343b2dc764ba6.jpg";